module.exports = __webpack_public_path__ + "media/nomor-antrian.6f1f4bfd.mp3";